'use client';

import { Flex, Heading, Link, Separator, Text } from '@chakra-ui/react';
import { MarketBriefing, marketBriefingFakeData } from '@features/positions/marketBriefingFakeData';
import { DateTime } from 'luxon';

interface StoryCardProps {
  story: MarketBriefing;
}

const StoryCard = ({ story }: StoryCardProps) => {
  return (
    <Flex direction="column" gap={3}>
      {story.subtitle != null && (
        <Text
          fontSize="xs"
          fontWeight="bold"
          color="text.secondary"
          letterSpacing="wider"
          textTransform="uppercase"
        >
          {story.subtitle}
        </Text>
      )}
      <Heading fontSize="2xl" fontWeight="bold">
        {story.title}
      </Heading>
      <Text color="text.secondary" fontSize="md" lineHeight="tall">
        {story.content}
      </Text>
      <Text fontSize="xs" color="text.secondary">
        <Link href={story.link} target="_blank" textDecoration="underline" color="text.secondary">
          Sourced from {story.source}
        </Link>
        {' · 2d ago'}
      </Text>
    </Flex>
  );
};

const MarketBriefingPage = () => {
  const today = DateTime.now().toFormat('EEEE, MMMM d, yyyy');

  return (
    <Flex direction="column" gap={6} maxW="3xl" mx="auto" py={10} px={4}>
      <Flex direction="column" gap={2}>
        <Text fontSize="sm" color="text.secondary">
          {today}
        </Text>
        <Heading fontSize="4xl" fontWeight="bold">
          Today's Stories
        </Heading>
        <Text fontSize="lg" color="text.secondary">
          Today's top crypto stories—carefully curated, unbiased, and market-focused.
        </Text>
      </Flex>

      <Flex direction="column" gap={10}>
        {marketBriefingFakeData.map((story, index) => (
          <Flex key={index} direction="column" gap={0}>
            {index > 0 && <Separator mb={10} />}
            <StoryCard story={story} />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default MarketBriefingPage;
